import React from 'react';
import { Link } from 'react-router';
import { menuConfig } from '../config/menubottomconfig';

class MenuBottom extends React.Component {

    fulfillsRequirements(requires){
        let { isAdmin, isSuperUser, isLoggedIn } = this.props.userState;

        let checkRequires = rule => {
            if(rule != null){
                if(rule == 'superuser'){
                    return isSuperUser;
                }
                if(rule == 'admin'){
                    return isAdmin;
                }
                if(rule == 'loggedin'){
                    return isLoggedIn;
                }
                if(rule == 'loggedout'){
                    return !isLoggedIn;
                }
                if(rule == 'regularuser') {
                    return !isAdmin && !isSuperUser;
                }
            } else {
                return true;
            }
        }

        if (typeof requires == 'object') {
            let result = [];
            requires.map( item => {
                result.push(checkRequires(item));
            });
            return result.some( el => el );
        } else {
            return checkRequires(requires);
        }
    }

    dispatchAction(actionType, addtionalProps) {
        let extraProps = (actionType=='SHOW_POPUP')
            ? {popupProps: addtionalProps}
            : addtionalProps;

        this.props.appActions.customAction(actionType, extraProps);
    }

    renderMenuItem(item, i){
        if(this.fulfillsRequirements(item.requires)) {
            return (
                <li className='menu-item' key={'menu_'+i}>
                        { item.action
                            ? <span onClick={this.dispatchAction.bind(this, item.action, item.addtionalProps)}>{ item.title }</span>
                            : <Link to={'/'+item.path}>{ item.title }</Link> }
                        { item.submenu ? this.renderSubMenu(item.submenu, i) : '' }
                </li>
            )
        }
    }

    renderSubMenu(submenu,i){
        if(submenu.length > 0) {
            return (
                <ul className='menu-secondary'>
                { submenu.length ? submenu.map((subitem, j) => {
                    if(this.fulfillsRequirements(subitem.requires)) {
                        return (    
                            <li className='menu-item' key={'menu_'+(i*100+j)}>
                                <Link to={'/'+subitem.path}>{ subitem.title }</Link>
                            </li>
                        );
                    }
                }) : null }
                </ul>
            )
        }
    }

    render() {
        return (
            <ul className='menu-primary'>
                { menuConfig.length ? menuConfig.map( (item, i) =>
                    { return this.renderMenuItem(item, i) }
                ) : null }
            </ul>
        )
    }

}

export default MenuBottom;



// WEBPACK FOOTER //
// ./source/components/menubottom.js